import createIcon from '../../createIcon';

/**
 * @component @name AudioFile
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2QzQuOSAyIDQuMDEgMi45IDQuMDEgNEw0IDIwQzQgMjEuMSA0Ljg5IDIyIDUuOTkgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhMMTQgMlpNMTYgMTNIMTNWMTYuNzVDMTMgMTcuOTkgMTEuOTkgMTkgMTAuNzUgMTlDOS41MSAxOSA4LjUgMTcuOTkgOC41IDE2Ljc1QzguNSAxNS41MSA5LjUxIDE0LjUgMTAuNzUgMTQuNUMxMS4yMSAxNC41IDExLjY0IDE0LjY0IDEyIDE0Ljg4VjExSDE2VjEzWk0xMyA5VjMuNUwxOC41IDlIMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AudioFile = createIcon('AudioFile', [
  [
    'path',
    {
      d: 'M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 13H13V16.75C13 17.99 11.99 19 10.75 19C9.51 19 8.5 17.99 8.5 16.75C8.5 15.51 9.51 14.5 10.75 14.5C11.21 14.5 11.64 14.64 12 14.88V11H16V13ZM13 9V3.5L18.5 9H13Z',
      key: '1oqa06',
    },
  ],
]);

export default AudioFile;
